import React, {  useEffect } from 'react';
import CustomerSupplierForm from '../../ClientSettings/CustomerSupplierManager/CustomerSupplierForm';
import {
  Modal,
  ModalBody
} from 'reactstrap';
import { AddCustomerSupplierPayloadType } from '../../../commonTypes/clientSettingsTypes';
import { ModalTitle } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { addCustomerSupplierAction, getAllCustomerSupplierAction, getAllTypesLedgerListAction, getAllTypesWithTaxListAction, resetClientSettingsSuccess } from '../../../redux/clientSettings';
import toast, { Toaster } from 'react-hot-toast';

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  client_code: any;
  type: string | null;
};


const CustomerSupplierModal = ({
  modal,
  toggleModal,
  client_code,
  type
}: AppProps) => {
  const dispatchAction = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);
  const clientSettingsSuccess = useSelector((state: RootState) => state.clientSettings.success);
  const customerSupplierFetching = useSelector((state: RootState) => state.clientSettings.fetching);

  useEffect(() => {
    dispatchAction(resetClientSettingsSuccess());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmitData = (data: AddCustomerSupplierPayloadType) => {
    if (token && client_code) {
      let finalData = {
        ...data,
        token,
        client_code,
      }
      dispatchAction(addCustomerSupplierAction(finalData));
    }
  };

  const handleAddCustomerSupplierSuccess = () => {
    if (clientSettingsSuccess && modal) {
      toast.success('Customer/Supplier Added Successfully!', {
        duration: 2000
      });
      dispatchAction(resetClientSettingsSuccess());
      dispatchAction(getAllCustomerSupplierAction({ token, client_code,limit:20,offset:0 }));
      dispatchAction(getAllTypesLedgerListAction({ token, client_code }));
      dispatchAction(getAllTypesWithTaxListAction({ token, client_code }));
      toggleModal();
    }
  };

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className='modal-styles'
        size='lg'
      >
        <ModalTitle className='pt-4 pl-4'>Add Customer/Supplier</ModalTitle>
        <ModalBody className='pr-4 pl-4'>
          <CustomerSupplierForm
            handleSubmitData={handleSubmitData}
            isModal={true}
            client_code={client_code}
            toggleModal={toggleModal}
            customerSupplierFetching={customerSupplierFetching}
          />
        </ModalBody>
      </Modal>
      <Toaster />
      {handleAddCustomerSupplierSuccess()}
    </>
  )
};

export default CustomerSupplierModal;